import { render, staticRenderFns } from "./DataNotice.vue?vue&type=template&id=c2f884ba&scoped=true"
import script from "./DataNotice.vue?vue&type=script&lang=ts&setup=true"
export * from "./DataNotice.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DataNotice.vue?vue&type=style&index=0&id=c2f884ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f884ba",
  null
  
)

export default component.exports